
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { Contact } from "./contacts/types";
import { ContactFormFields } from "./contacts/ContactFormFields";
import { JobsSelection } from "./contacts/JobsSelection";
import { useContactForm } from "@/hooks/companies/useContactForm";

interface ContactEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  contact: Contact | null;
  companyId: string;
  onSave: () => void;
}

export const ContactEditModal = ({
  isOpen,
  onClose,
  contact,
  companyId,
  onSave
}: ContactEditModalProps) => {
  const {
    formData,
    setFormData,
    isSubmitting,
    selectedJobs,
    setSelectedJobs,
    handleChange,
    submitForm
  } = useContactForm({
    companyId,
    onSuccess: onSave,
    contactId: contact?.id
  });
  
  useEffect(() => {
    if (isOpen && contact) {
      setFormData({ ...contact });
    }
  }, [isOpen, contact, setFormData]);
  
  if (!contact) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Edit Contact</DialogTitle>
        </DialogHeader>
        
        <form onSubmit={submitForm} className="space-y-4 mt-4">
          <ContactFormFields 
            formData={formData} 
            onChange={handleChange} 
            disabled={isSubmitting}
          />
          
          <JobsSelection 
            companyId={companyId}
            contactId={formData.id}
            selectedJobs={selectedJobs}
            onJobsChange={setSelectedJobs}
            disabled={isSubmitting}
          />
          
          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-digger-blue hover:bg-digger-blue-light"
              disabled={isSubmitting}
            >
              Save Changes
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
